@let paragraphColor = style().textColor | color;
<section #sectionElement [style.background-color]="style().backgroundColor | color">
  <div class="container">
    <div class="row">
      <div class="col-xs-12-col-lg-12">
        @if (title()) {
          <app-title [titles]="[title()]" class="title" />
        }
        <p #textWrapperElement [style.color]="paragraphColor" class="paragraph">
          @for (split of text(); track split; let i = $index) {
            <span #textElements [innerHTML]="split + ' '" class="hide"></span>
          }
        </p>
      </div>
    </div>
  </div>
</section>
